{
  "ClientConfiguration_Table_Headers_Description": "Description",
  "ClientConfiguration_Table_Headers_TelSys": "Telephony Server",
  "ClientConfiguration_Table_Headers_Partition": "Partition",
  "ClientConfiguration_Table_Headers_Device": "Device",
  "ClientConfiguration_Admin_Filters_CME": "CME",
  "ClientConfiguration_Admin_Filters_IncludeChildCMEs": "Include Child CME",
  "ClientConfiguration_Admin_Filters_Search": "Search",
  "ClientConfiguration_Footer_Add": "Add",
  "ClientConfiguration_Footer_View": "View",
  "ClientConfiguration_Footer_Change": "Change",
  "ClientConfiguration_Footer_Delete": "Delete",
  "ClientConfiguration_Footer_Selected": "{} Selected",
  "ClientConfiguration_Footer_NoRows": "Nothing to see here...",
  "ClientConfiguration_No_Available_CMEs": "You have no CMEs with the required capabilities",
  "NAME": "ClientConfigurationLanguage"
}